import type { ReactNode } from "react";
import { Menu, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  title: string;
  href: string;
}

interface SectionBarProps {
  pageTitle: string;
  sidebarOpen: boolean;
  onMenuClick: () => void;
  rightSlot?: ReactNode;
  breadcrumbs?: BreadcrumbItem[];
}

export function SectionBar({
  pageTitle,
  sidebarOpen,
  onMenuClick,
  rightSlot,
  breadcrumbs,
}: SectionBarProps) {
  return (
    <div className="shrink-0 flex items-center gap-2 sm:gap-3 h-10 px-3 sm:px-4 border-b border-border bg-surface">
      <button
        onClick={onMenuClick}
        className={`p-1.5 rounded-full transition-colors cursor-pointer ${
          sidebarOpen
            ? "bg-brand-cyan/20 text-brand-cyan hover:bg-brand-cyan/30"
            : "text-muted hover:bg-brand-cyan/15 hover:text-brand-cyan"
        }`}
        aria-label={sidebarOpen ? "Close navigation menu" : "Open navigation menu"}
      >
        <Menu className="h-4 w-4" />
      </button>

      {breadcrumbs && breadcrumbs.length > 0 ? (
        <nav className="flex items-center gap-1.5 min-w-0" aria-label="Breadcrumb">
          {breadcrumbs.map((crumb) => (
            <span key={crumb.href} className="hidden sm:flex items-center gap-1.5">
              <Link
                to={crumb.href}
                className="text-sm text-muted hover:text-secondary transition-colors"
              >
                {crumb.title}
              </Link>
              <ChevronRight className="h-3.5 w-3.5 text-muted/50 shrink-0" />
            </span>
          ))}
          <span className="text-sm text-secondary font-medium truncate">{pageTitle}</span>
        </nav>
      ) : (
        <span className="text-sm text-secondary font-medium cursor-default">{pageTitle}</span>
      )}

      {rightSlot && <div className="ml-auto shrink-0 flex items-center">{rightSlot}</div>}
    </div>
  );
}
